module.exports = __webpack_public_path__ + "img/footwear-icon.ea8c41a69ec35dd0c339ca498d59b666.svg";